"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportReasons = exports.Reportables = exports.ReportReplyReasons = exports.ReportReviewReasons = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ReportReasons;

var ReportReviewReasons = {
  VIOLATION: 'VIOLATION',
  DUPLICATE: 'DUPLICATE',
  BAD_AUTHOR: 'BAD_AUTHOR',
  OFFENSIVE: 'OFFENSIVE',
  OTHER: 'OTHER'
};
exports.ReportReviewReasons = ReportReviewReasons;
var ReportReplyReasons = {
  VIOLATION: 'VIOLATION',
  OFFENSIVE: 'OFFENSIVE',
  BAD_AUTHOR: 'BAD_AUTHOR',
  OTHER: 'OTHER'
};
exports.ReportReplyReasons = ReportReplyReasons;
var Reportables = {
  REVIEW: 'REVIEW',
  REPLY: 'REPLY'
};
exports.Reportables = Reportables;
var ReportReasons = (_ReportReasons = {}, (0, _defineProperty2.default)(_ReportReasons, Reportables.REVIEW, ReportReviewReasons), (0, _defineProperty2.default)(_ReportReasons, Reportables.REPLY, ReportReplyReasons), _ReportReasons);
exports.ReportReasons = ReportReasons;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/reviews/ReportReasons.js
// module id = 428
// module chunks = 209 210 211 212